// 配置详情列表

// ALERT_TITLE("提示类型的标题", "0000")
// ALERT_VALUE("提示类型的内容", "0001")
// ASSESS_TITLE("评估类型的标题", "0100")
// ASSESS_VALUE("评估类型的内容", "0101")
// INPUT_TITLE("填写项内容标题", "0200")
// INPUT_VALUE("填写项内容输入", "0201")
// ANNULAR_DEFAULT("360评估默认行不作为标题或内容", "0302")
export const BLOCK_TYPE_KEY = {
  '00': 'ALERT',
  '01': 'ASSESS',
  '02': 'WRITE',
  '03': 'ANNULAR',
  '04': 'RESULT_CHECKBOX'
}
export const BLOCK_DEFAULT_VALUES = {
  // 提示类型
  ALERT: {
      type: 'ALERT',
      name: '提示项',
      valueType: '0000', // 当前block类型的填写值附着在那个line或者key上面
      requestRowMaps: {  // 提交的时候：抽取对应的值，形成唯一value
        '0000': 'name',
        '0001': 'text'
      },
      preViewRowMaps: null,   // 下面有函数会根据requestRowMaps自动添加
      defaultValue: () => ({ name: '', text: '' }), // 组件内部使用的values，编辑数据的时候也会格式化成这个样子
  },

  // 评估类型
  ASSESS: {
      type: 'ASSESS',
      name: '评估项',
      valueType: '0100', // 当前block类型的填写值附着在那个line或者key上面
      requestRowMaps: {    // 提交的时候：抽取对应的值，形成唯一value
        '0100': 'name',
        '0101': 'assessId',
      },
      preViewRowMaps: null,   // 下面有函数会根据requestRowMaps自动添加
      defaultValue: () => ({ assessId: null, name: '' })  // 组件内部使用的values，编辑数据的时候也会格式化成这个样子
  },

  // 填写类型
  WRITE: {
      type: 'WRITE',  
      name: '填写项',
      valueType: '0200', // 当前block类型的填写值附着在那个line或者key上面
      requestRowMaps: {  // 提交的时候：抽取对应的值，形成唯一value
        '0200': 'name',
        '0201': 'placeholder'
      },
      preViewRowMaps: null,   // 下面有函数会根据requestRowMaps自动添加
      defaultValue: () => ({ name: '', placeholder: '' })  // 组件内部使用的values，编辑数据的时候也会格式化成这个样子
  },

  // 360环节
  ANNULAR: {
    type: 'ANNULAR',  
    name: '360邀请/确认',
    valueType: '0302', // 当前block类型的填写值附着在那个line或者key上面
    requestRowMaps: {  // 提交的时候：抽取对应的值，形成唯一value
      '0302': 'default',
    },
    preViewRowMaps: null,   // 下面有函数会根据requestRowMaps自动添加
    defaultValue: () => ({ default: '' })  // 组件内部使用的values，编辑数据的时候也会格式化成这个样子
  },
  
  // 结果复议环节的是否保持复议结果
  RESULT_CHECKBOX: {
    type: 'RESULT_CHECKBOX',  
    name: '结果复议-是否保持复议结果',
    valueType: '0400', // 当前block类型的填写值附着在那个line或者key上面
    requestRowMaps: {  // 提交的时候：抽取对应的值，形成唯一value
      '0400': 'default',
    },
    preViewRowMaps: null,   // 下面有函数会根据requestRowMaps自动添加
    defaultValue: () => ({ default: '0' })  // 组件内部使用的values，编辑数据的时候也会格式化成这个样子
  }
}

/**
 * BLOCK_DEFAULT_VALUES的反向Map
 */
Object.keys(BLOCK_DEFAULT_VALUES).forEach(key => {
    const requestRowMaps = BLOCK_DEFAULT_VALUES[key]['requestRowMaps']
    const preViewRowMaps = {}
    Object.keys(requestRowMaps).forEach(code => { preViewRowMaps[requestRowMaps[code]] = code })
    BLOCK_DEFAULT_VALUES[key]['preViewRowMaps'] = preViewRowMaps
})